var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3462 1.07568H2.65385C2.01659 1.07568 1.5 1.59228 1.5 2.22953V12.0372C1.5 12.6745 2.01659 13.1911 2.65385 13.1911H15.3462C15.9834 13.1911 16.5 12.6745 16.5 12.0372V2.22953C16.5 1.59228 15.9834 1.07568 15.3462 1.07568Z",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.51807L8.26154 6.5845C8.46887 6.70622 8.73017 6.77287 9 6.77287C9.26983 6.77287 9.53113 6.70622 9.73846 6.5845L16.5 2.51807",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ee0cd33865d694b64f2ff3c1b405bbdd.svg";
export { ForwardRef as ReactComponent };